import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

/**
 * Creates a localStorage persister for TanStack Query
 * This allows the query cache to be saved to localStorage and restored on page load
 */
export const localStoragePersister = createAsyncStoragePersister({
  storage: globalThis.localStorage,
});
